import { Color, Euler, Quaternion, Vector2 } from "three";
const MapConfig = {
    COLOR: new Color(0xfffff1),
    GROUND_WIDTH: 128,
    GROUND_HEIGHT: 128,
    SEGMENTS: new Vector2(128, 128),
    HEIGHTMAP_HEIGHT: 6,
    GROUND_ROTATION: new Quaternion().setFromEuler(new Euler(-Math.PI / 2, 0, 0)),
    VOID_LEVEL: -32,
    SKY_LEVEL: 32,
    CAST_SHADOW: false,
    RECEIVE_SHADOW: true,
};
export { MapConfig };
